'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var unixfsEngine = require('ipfs-unixfs-engine');

var importer = unixfsEngine.importer;
var exporter = unixfsEngine.exporter;

var promisify = require('promisify-es6');

var pull = require('pull-stream');

var sort = require('pull-sort');

var pushable = require('pull-pushable');

var toStream = require('pull-stream-to-stream');

var toPull = require('stream-to-pull-stream');

var deferred = require('pull-defer');

var waterfall = require('async/waterfall');

var isStream = require('is-stream');

var isSource = require('is-pull-stream').isSource;

var Duplex = require('readable-stream').Duplex;

var OtherBuffer = require('buffer').Buffer;

var CID = require('cids');

var toB58String = require('multihashes').toB58String;

var errCode = require('err-code');

var parseChunkerString = require('../utils').parseChunkerString;

var WRAPPER = 'wrapper/';

function noop() {}

function prepareFile(self, opts, file, callback) {
  opts = opts || {};
  var cid = new CID(file.multihash);

  if (opts.cidVersion === 1) {
    cid = cid.toV1();
  }

  waterfall([function (cb) {
    return opts.onlyHash ? cb(null, file) : self.object.get(file.multihash, Object.assign({}, opts, {
      preload: false
    }), cb);
  }, function (node, cb) {
    var b58Hash = cid.toBaseEncodedString();
    var size = node.size;

    if (Buffer.isBuffer(node)) {
      size = node.length;
    }

    cb(null, {
      path: opts.wrapWithDirectory ? file.path.substring(WRAPPER.length) : file.path || b58Hash,
      hash: b58Hash,
      size: size
    });
  }], callback);
}

function normalizeContent(opts, content) {
  if (!Array.isArray(content)) {
    content = [content];
  }

  return content.map(function (data) {
    // Buffer input
    if (Buffer.isBuffer(data)) {
      data = {
        path: '',
        content: pull.values([data])
      };
    } // Readable stream input


    if (isStream.readable(data)) {
      data = {
        path: '',
        content: toPull.source(data)
      };
    }

    if (isSource(data)) {
      data = {
        path: '',
        content: data
      };
    }

    if (data && data.content && typeof data.content !== 'function') {
      if (Buffer.isBuffer(data.content)) {
        data.content = pull.values([data.content]);
      }

      if (isStream.readable(data.content)) {
        data.content = toPull.source(data.content);
      }
    }

    if (opts.wrapWithDirectory && !data.path) {
      throw new Error('Must provide a path when wrapping with a directory');
    }

    if (opts.wrapWithDirectory) {
      data.path = WRAPPER + data.path;
    }

    return data;
  });
}

function preloadFile(self, opts, file) {
  var isRootFile = opts.wrapWithDirectory ? file.path === '' : !file.path.includes('/');
  var shouldPreload = isRootFile && !opts.onlyHash && opts.preload !== false;

  if (shouldPreload) {
    self._preload(file.hash);
  }

  return file;
}

function pinFile(self, opts, file, cb) {
  // Pin a file if it is the root dir of a recursive add or the single file
  // of a direct add.
  var pin = 'pin' in opts ? opts.pin : true;
  var isRootDir = !file.path.includes('/');
  var shouldPin = pin && isRootDir && !opts.onlyHash && !opts.hashAlg;

  if (shouldPin) {
    return self.pin.add(file.hash, {
      preload: false
    }, function (err) {
      return cb(err, file);
    });
  } else {
    cb(null, file);
  }
}

var AddHelper =
/*#__PURE__*/
function (_Duplex) {
  _inherits(AddHelper, _Duplex);

  function AddHelper(pullStream, push, options) {
    var _this;

    _classCallCheck(this, AddHelper);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AddHelper).call(this, Object.assign({
      objectMode: true
    }, options)));
    _this._pullStream = pullStream;
    _this._pushable = push;
    _this._waitingPullFlush = [];
    return _this;
  }

  _createClass(AddHelper, [{
    key: "_read",
    value: function _read() {
      var _this2 = this;

      this._pullStream(null, function (end, data) {
        while (_this2._waitingPullFlush.length) {
          var cb = _this2._waitingPullFlush.shift();

          cb();
        }

        if (end) {
          if (end instanceof Error) {
            _this2.emit('error', end);
          }
        } else {
          _this2.push(data);
        }
      });
    }
  }, {
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      this._waitingPullFlush.push(callback);

      this._pushable.push(chunk);
    }
  }]);

  return AddHelper;
}(Duplex);

module.exports = function files(self) {
  function _addPullStream() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var chunkerOptions;

    try {
      chunkerOptions = parseChunkerString(options.chunker);
    } catch (err) {
      return pull.map(function () {
        throw err;
      });
    }

    var opts = Object.assign({}, {
      shardSplitThreshold: self._options.EXPERIMENTAL.sharding ? 1000 : Infinity
    }, options, chunkerOptions);

    if (opts.hashAlg && opts.cidVersion !== 1) {
      opts.cidVersion = 1;
    }

    var total = 0;
    var prog = opts.progress || noop;

    var progress = function progress(bytes) {
      total += bytes;
      prog(total);
    };

    opts.progress = progress;
    return pull(pull.map(normalizeContent.bind(null, opts)), pull.flatten(), importer(self._ipld, opts), pull.asyncMap(prepareFile.bind(null, self, opts)), pull.map(preloadFile.bind(null, self, opts)), pull.asyncMap(pinFile.bind(null, self, opts)));
  }

  function _catPullStream(ipfsPath, options) {
    if (typeof ipfsPath === 'function') {
      throw new Error('You must supply an ipfsPath');
    }

    options = options || {};
    ipfsPath = normalizePath(ipfsPath);
    var pathComponents = ipfsPath.split('/');
    var restPath = normalizePath(pathComponents.slice(1).join('/'));

    var filterFile = function filterFile(file) {
      return restPath && file.path === restPath || file.path === ipfsPath;
    };

    if (options.preload !== false) {
      self._preload(pathComponents[0]);
    }

    var d = deferred.source();
    pull(exporter(ipfsPath, self._ipld, options), pull.collect(function (err, files) {
      if (err) {
        return d.abort(err);
      }

      if (files && files.length > 1) {
        files = files.filter(filterFile);
      }

      if (!files || !files.length) {
        return d.abort(new Error('No such file'));
      }

      var file = files[0];
      var content = file.content;

      if (!content && file.type === 'dir') {
        return d.abort(new Error('this dag node is a directory'));
      }

      d.resolve(content);
    }));
    return d;
  }

  function _lsPullStreamImmutable(ipfsPath, options) {
    options = options || {};
    var path = normalizePath(ipfsPath);
    var recursive = options.recursive;
    var pathComponents = path.split('/');
    var pathDepth = pathComponents.length;
    var maxDepth = recursive ? global.Infinity : pathDepth;
    options.maxDepth = options.maxDepth || maxDepth;

    if (options.preload !== false) {
      self._preload(pathComponents[0]);
    }

    return pull(exporter(ipfsPath, self._ipld, options), pull.filter(function (node) {
      return recursive ? node.depth >= pathDepth : node.depth === pathDepth;
    }), pull.map(function (node) {
      var cid = new CID(node.hash);
      node = Object.assign({}, node, {
        hash: cid.toBaseEncodedString()
      });
      delete node.content;
      return node;
    }));
  }

  return {
    add: function () {
      var add = promisify(function (data, options, callback) {
        if (typeof options === 'function') {
          callback = options;
          options = {};
        }

        options = options || {};
        var ok = Buffer.isBuffer(data) || isStream.readable(data) || Array.isArray(data) || OtherBuffer.isBuffer(data) || typeof data === 'object' || isSource(data);

        if (!ok) {
          return callback(new Error('first arg must be a buffer, readable stream, pull stream, an object or array of objects'));
        } // CID v0 is for multihashes encoded with sha2-256


        if (options.hashAlg && options.cidVersion !== 1) {
          options.cidVersion = 1;
        }

        pull(pull.values([data]), _addPullStream(options), sort(function (a, b) {
          if (a.path < b.path) return 1;
          if (a.path > b.path) return -1;
          return 0;
        }), pull.collect(callback));
      });
      return function () {
        var args = Array.from(arguments); // If we files.add(<pull stream>), then promisify thinks the pull stream
        // is a callback! Add an empty options object in this case so that a
        // promise is returned.

        if (args.length === 1 && isSource(args[0])) {
          args.push({});
        }

        return add.apply(null, args);
      };
    }(),
    addReadableStream: function addReadableStream(options) {
      options = options || {};
      var p = pushable();
      var s = pull(p, _addPullStream(options));
      var retStream = new AddHelper(s, p);
      retStream.once('finish', function () {
        return p.end();
      });
      return retStream;
    },
    addPullStream: _addPullStream,
    cat: promisify(function (ipfsPath, options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (typeof callback !== 'function') {
        throw new Error('Please supply a callback to ipfs.files.cat');
      }

      pull(_catPullStream(ipfsPath, options), pull.collect(function (err, buffers) {
        if (err) {
          return callback(err);
        }

        callback(null, Buffer.concat(buffers));
      }));
    }),
    catReadableStream: function catReadableStream(ipfsPath, options) {
      return toStream.source(_catPullStream(ipfsPath, options));
    },
    catPullStream: function catPullStream(ipfsPath, options) {
      return _catPullStream(ipfsPath, options);
    },
    get: promisify(function (ipfsPath, options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      options = options || {};

      if (options.preload !== false) {
        var pathComponents;

        try {
          pathComponents = normalizePath(ipfsPath).split('/');
        } catch (err) {
          return setImmediate(function () {
            return callback(errCode(err, 'ERR_INVALID_PATH'));
          });
        }

        self._preload(pathComponents[0]);
      }

      pull(exporter(ipfsPath, self._ipld, options), pull.asyncMap(function (file, cb) {
        if (file.content) {
          pull(file.content, pull.collect(function (err, buffers) {
            if (err) {
              return cb(err);
            }

            file.content = Buffer.concat(buffers);
            cb(null, file);
          }));
        } else {
          cb(null, file);
        }
      }), pull.collect(callback));
    }),
    getReadableStream: function getReadableStream(ipfsPath, options) {
      options = options || {};

      if (options.preload !== false) {
        var pathComponents;

        try {
          pathComponents = normalizePath(ipfsPath).split('/');
        } catch (err) {
          return toStream.source(pull.error(errCode(err, 'ERR_INVALID_PATH')));
        }

        self._preload(pathComponents[0]);
      }

      return toStream.source(pull(exporter(ipfsPath, self._ipld, options), pull.map(function (file) {
        if (file.content) {
          file.content = toStream.source(file.content);
          file.content.pause();
        }

        return file;
      })));
    },
    getPullStream: function getPullStream(ipfsPath, options) {
      options = options || {};

      if (options.preload !== false) {
        var pathComponents;

        try {
          pathComponents = normalizePath(ipfsPath).split('/');
        } catch (err) {
          return pull.error(errCode(err, 'ERR_INVALID_PATH'));
        }

        self._preload(pathComponents[0]);
      }

      return exporter(ipfsPath, self._ipld, options);
    },
    lsImmutable: promisify(function (ipfsPath, options, callback) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      options = options || {};
      pull(_lsPullStreamImmutable(ipfsPath, options), pull.collect(function (err, values) {
        if (err) {
          callback(err);
          return;
        }

        callback(null, values);
      }));
    }),
    lsReadableStreamImmutable: function lsReadableStreamImmutable(ipfsPath, options) {
      return toStream.source(_lsPullStreamImmutable(ipfsPath, options));
    },
    lsPullStreamImmutable: _lsPullStreamImmutable
  };
};

function normalizePath(path) {
  if (Buffer.isBuffer(path)) {
    path = toB58String(path);
  }

  if (CID.isCID(path)) {
    path = path.toBaseEncodedString();
  }

  if (path.indexOf('/ipfs/') === 0) {
    path = path.substring('/ipfs/'.length);
  }

  if (path.charAt(path.length - 1) === '/') {
    path = path.substring(0, path.length - 1);
  }

  return path;
}